function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Logo Alegro");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "main-header__logo_l4",
  fill: "#F3B2D0",
  d: "M138,19.9c-0.1-0.1,0-0.3,0.1-0.4c1.9-1.8,2.9-4.3,2.9-7.7c0-6.7-3.9-10.1-11.8-10.1h-13.7                                             c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0v26.3c0,0.1,0.1,0.2,0.2,0.2h11.6c0.1,0,0.2-0.1,0.2-0.2c0,0,0,0,0,0l-0.9-7.5                                             c0-0.1,0.1-0.2,0.2-0.2c0,0,0,0,0,0h0.1c0.1,0,0.2,0.1,0.3,0.2l4.4,7.7c0.1,0.1,0.2,0.2,0.3,0.2h11c0.1,0,0.2-0.1,0.2-0.2                                             c0,0,0-0.1,0-0.1L138,19.9z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "main-header__logo_l1",
  fill: "#F3B2D0",
  d: "M46.9,17l0.4-15c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0H33.5c-0.1,0-0.2,0.1-0.2,0.2v26.3c0,0.1,0.1,0.2,0.2,0.2                                             h23.4c0.1,0,0.2-0.1,0.2-0.2V17c0-0.1-0.1-0.2-0.2-0.2c0,0,0,0,0,0L47,17.1C46.9,17.1,46.9,17.1,46.9,17C46.9,17,46.9,17,46.9,17z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "main-header__logo_l2",
  fill: "#F3B2D0",
  d: "M71.6,17.9v1.8c0,0.1,0.1,0.2,0.2,0.2h0l12.1-0.1c0.1,0,0.2,0.1,0.2,0.2c0,0,0,0,0,0v8.3                                             c0,0.1-0.1,0.2-0.2,0.2H59.5c-0.1,0-0.2-0.1-0.2-0.2V2c0-0.1,0.1-0.2,0.2-0.2h24.2c0.1,0,0.2,0.1,0.2,0.2v8.3c0,0.1-0.1,0.2-0.2,0.2                                             c0,0,0,0,0,0l-11.9-0.1c-0.1,0-0.2,0.1-0.2,0.2l0,0v1.8c0,0.1,0.1,0.2,0.2,0.2c0,0,0,0,0,0l9.1-0.3c0.1,0,0.2,0.1,0.2,0.2                                             c0,0,0,0,0,0v5.3c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0l-9.1-0.3C71.7,17.7,71.6,17.8,71.6,17.9C71.6,17.9,71.6,17.9,71.6,17.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "main-header__logo_l3",
  fill: "#F3B2D0",
  d: "M102.8,10.7c3.1-0.1,6.1,0.4,9,1.5c0.1,0,0.2,0,0.3-0.1c0,0,0,0,0-0.1V2.8c0-0.1-0.1-0.2-0.2-0.3                                             c-3.1-1.1-6.4-1.6-9.7-1.4c-10.5,0-17.3,5-17.3,14c0,8,6.8,14,15.7,14c3.8,0.1,7.7-0.5,11.3-1.7c0.1,0,0.2-0.1,0.2-0.2l-0.3-13.4                                             c0-0.1-0.1-0.2-0.2-0.2h-10.5c-0.1,0-0.2,0.1-0.2,0.2c0,0,0,0,0,0l0.6,5.2c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0,0,0H101                                             c-3.2,0-5.1-1.6-5.1-4.1C95.9,12.3,98.9,10.7,102.8,10.7z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-69.02, -8.931)"
}, /*#__PURE__*/React.createElement("path", {
  id: "main-header__logo__triangle",
  className: "main-header__logo__triangle",
  fill: "#EB008C",
  d: "M101.8,37.1L85.6,9c-0.1-0.1-0.2-0.1-0.3-0.1c0,0-0.1,0-0.1,0.1L69,37.1c-0.1,0.1,0,0.2,0.1,0.3 c0,0,0.1,0,0.1,0h32.4c0.1,0,0.2-0.1,0.2-0.2C101.9,37.2,101.8,37.2,101.8,37.1z"
}));

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "main-header__logo__smile",
  fill: "#EB008C",
  d: "M129.2,46.3c7.2,0,14.2-2.2,20.1-6.4c0.1-0.1,0.1-0.2,0.1-0.3l-4.7-8.2c-0.1-0.1-0.2-0.1-0.3-0.1                                             c0,0,0,0,0,0c-4.5,3-9.8,4.6-15.2,4.6c-5.4,0-10.7-1.6-15.1-4.6c-0.1-0.1-0.2,0-0.3,0.1c0,0,0,0,0,0l-4.7,8.2                                             c-0.1,0.1,0,0.2,0.1,0.3C115,44.1,122,46.4,129.2,46.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  className: "main-header__logo__circle",
  fill: "#EB008C",
  cx: 156.9,
  cy: 15.1,
  r: 14
});

var SvgSidebarLogo = function SvgSidebarLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.9 46.3",
    enableBackground: "new 0 0 170.9 46.3",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSidebarLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sidebar-logo.2b90df97.svg";
export { ForwardRef as ReactComponent };